import styled from "styled-components";

export const Line = styled.div`
  height: 1px;
  background: #f1f3f5;
  margin-top: 12px;
`;

export const MarketSearchContainer = styled.div`
  & header {
    padding: 0 16px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    margin-top: 9px;

    & .arrowBack {
      width: 24px;
      height: 24px;
      cursor: pointer;
      margin-right: 11px;
      margin-left: -3px;
    }

    & .inputSearch {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      background: #f1f3f5;
      border-radius: 8px;
      overflow: hidden;
      box-sizing: border-box;

      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        /* width: 36px; */
        /* height: 36px; */
        padding: 8px;
        margin-left: 4px;
        box-sizing: border-box;

        & img {
          height: 20px;
          width: 20px;
          color: #4a5056;
          cursor: pointer;
        }
      }

      & input {
        width: 100%;
        height: 100%;
        background-color: #f1f3f5;
        outline: none;
        border: none;

        font-size: 16px;
        line-height: 24px;

        padding-top: 8px;
        padding-bottom: 8px;
        margin-left: 3px;
        box-sizing: border-box;

        caret-color: #ff7a00;

        &::placeholder {
          color: #878e95;
          font-size: 0.8rem;
        }
      }

      & > img {
        margin-right: 14px;
        cursor: pointer;
      }
    }
  }

  & main {
    & .autoCompleteWordList {
      padding: 0 16px;
      overflow: auto;

      margin-bottom: 1px;
      height: calc(100vh - 134px);

      ::-webkit-scrollbar {
        width: 4px;
        cursor: pointer;
      }
      ::-webkit-scrollbar-thumb {
        background-color: #f1f3f5;
        border-radius: 4px;
        height: 80px;
        cursor: pointer;
      }

      & .autoCompleteWordItem {
        display: flex;
        align-items: center;
        margin-left: -9px;

        font-weight: 400;
        font-size: 14px;
        line-height: 20px;

        & img,
        span {
          cursor: pointer;
        }
      }
    }

    & .noneSearched {
      margin-top: 80px;
      text-align: center;
      font-size: 14px;
      line-height: 20px;
    }

    & .searchedList {
      margin-top: 15px;

      & .searchedItem {
        margin-bottom: 12px;
      }
    }
  }
`;
